<div class="flex">
  <!--'border-color': borderColor -->
  <div class="tag" [ngStyle]="{ 'background-color': backgroundColor, 'color': fontColor}">
    {{ content }}
  </div>
</div>

